import React from "react";
import "./CollapseButton.scss";

const CollapseButton = ({ 
  isOpen, 
  onClick, 
  addText = "Add another contact", 
  removeText = "Remove additional contact",
  color = "blue",
  variant = "expand" // 'expand' or 'collapse'
}) => {
  if (variant === "collapse") {
    return (
      <div
        className="form-collapse-table"
        data-component="collapse"
        onClick={onClick}
      >
        <div className="collapse-icon">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 100 100"
              className="collapse-icon-svg"
            >
              <line
                x1="30"
                y1="30"
                x2="70"
                y2="70"
                stroke="rgba(245, 34, 45, 1)"
                strokeWidth="7"
              />
              <line
                x1="70"
                y1="30"
                x2="30"
                y2="70"
                stroke="rgba(245, 34, 45, 1)"
                strokeWidth="7"
              />
            </svg>
          </div>
          <div className="form-collapse-mid">
            {removeText}
          </div>
        </div>
      </div>
    );
  }

  // Default expand variant
  return (
    <div 
      className="form-collapse-table"
      data-component="collapse"
      onClick={onClick}
      style={{ display: isOpen ? 'none' : 'block' }}
    >
      <div className="plus-icon">
        <div className="plus-icon-svg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 100 100"
          >
            <circle
              cx="50"
              cy="50"
              r="48"
              stroke={color}
              strokeWidth="2"
              fill="none"
            />
            <line
              x1="30"
              y1="50"
              x2="70"
              y2="50"
              stroke={color}
              strokeWidth="5"
            />
            <line
              x1="50"
              y1="30"
              x2="50"
              y2="70"
              stroke={color}
              strokeWidth="5"
            />
          </svg>
        </div>
        <div className="form-collapse-mid">
          {addText}
        </div>
      </div>
    </div>
  );
};

export default CollapseButton; 